import React, { Children, useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CustomerCare from "../../Components/CustomerCare";
import Payroll from "../../Components/Payroll";
import Pagination from "../../Components/Pagination";
import close from "../../images/close.svg";
import SportsBetSlip from "./components/SportsBetSlip";
import SportBet from "./components/SportsBet";
import MobileLogoCards from "./components/MobileLogoCards";
import BannerSlider from "./components/BannerSlider";
import AllCountries from "./components/AllCountries";
import TopLeagues from "./components/TopLeagues";
import LogoCards from "./components/LogoCard";
import Layout from "../../layout";
import MobileSportsBetslip from "./components/MobileSportsBetSlip";
import { transformApiData } from "../../utils";
import {
  useGetCategoriesQuery,
  useGetCountriesQuery,
  useGetGamesQuery,
  useGetTopLeaguesQuery,
} from "../../store/apis";
import { leaguesData } from "./data";
import MobileGames from "./components/MobileGames";
import { useDispatch, useSelector } from "react-redux";
import { setLeagues } from "../../store/league-slice";
import { useTheme } from "../../context/ThemeContext";
import BottomNavigation from "../../Components/BottonNavigation";
import {
  selectIsCountryLoading,
  selectIsLeagueLoading,
  setCountries,
  setCountryLoading,
  setLeagueLoading,
} from "../../store/country-slice";
const HomeLayout = ({ children }) => {
  const [activeOdd, setActiveOdd] = useState(null);
  const { data: topLeagueData, isLoading: isTopLeagueLoading } =
    useGetTopLeaguesQuery();
  const { data: countriesData, isLoading: isCountryLoading } =
    useGetCountriesQuery();
  const dispatch = useDispatch();
  useEffect(() => {
    if (topLeagueData) {
      dispatch(setLeagues(topLeagueData));
    }
  }, [topLeagueData]);
  useEffect(() => {
    dispatch(setCountryLoading(isCountryLoading));
  }, [isCountryLoading, dispatch]);
  useEffect(() => {
    dispatch(setLeagueLoading(isTopLeagueLoading));
  }, [isTopLeagueLoading, dispatch]);
  useEffect(() => {
    if (countriesData) {
      dispatch(setCountries(countriesData));
    }
  }, [countriesData]);

  const handleOddClick = (id) => {
    setActiveOdd((prev) => (prev === id ? null : id)); // Toggle active state
  };
  const { bets } = useSelector((state) => state.betSlip);
  const { isDarkMode } = useTheme();

  const [isOpen, setIsOpen] = useState(false);

  const handleToggles = () => {
    setIsOpen(!isOpen);
  };
  return (
    <Layout>
      <div className="pb-[70px] s15:pb-[100px] dark:bg-darkblue">
        <div className="max-sm:px-[0px] px-[20px] xl:px-[30px] w-full max-w-[1780px] mx-auto">
          <div className="grid grid-cols-12 gap-5 md:gap-3 s18:gap-5">
            <div className="max-md:col-span-0 max-md:hidden md:col-span-3 lg:col-span-2 s15:col-span-2">
              <div className="w-full max-w-full s18:max-w-[238px]">
                <LogoCards />
                <TopLeagues isDarkMode={isDarkMode} />
                <AllCountries isDarkMode={isDarkMode} />
              </div>
            </div>
            <div className="max-md:col-span-12 md:col-span-9 lg:col-span-10 s15:col-span-7">
              <div className="s18:ml-[-35px]">
                {/* center one img slider */}
                <BannerSlider />
                {/* <MobileLogoCards /> */}
                <>{/* <MobileGames /> */}</>
                {children}
              </div>
              {/* Pagination */}
              <Pagination />
            </div>
            <SportsBetSlip isDarkMode={isDarkMode} />
          </div>
        </div>
      </div>
      <div className="hidden md:flex justify-center items-center fixed bottom-0 z-[9] left-[50%] translate-x-[-50%] w-full max-w-[428px] mx-auto rounded-[20px_20px_0px_0px] bg-bluedarkmode p-[30px_15px_12px] lg:p-[24px_15px_12px] s18:p-[40px_15px_25px]">
        <span
          className="select-none cursor-pointer border-solid  inline-flex flex-col items-center gap-[7px] p-[0px] text-white text-lg md:text-sm s18:text-[18px] font-medium leading-[100%]"
          onClick={handleToggles}
        >
          {isOpen ? (
            <>
              <span className="absolute -top-[20px] lg:-top-4 s18:top-[-22px] left-[50%] translate-x-[-50%] flex w-8 h-8 max-md:w-[38px] max-md:h-[38px] justify-center items-center bg-yellow rounded-[50%] text-black dark:bg-white text-[22px] md:text-abse s16:text-lg max-md:text-[22px] font-medium leading-[100%]">
                <img src={close} alt="Close" className="w-[14px] h-[14px]" />
              </span>
              Close
            </>
          ) : (
            <>
              <span className="absolute -top-[20px] lg:-top-4 s18:top-[-22px] left-[50%] translate-x-[-50%] flex w-8 h-8 max-md:w-[38px] max-md:h-[38px] justify-center items-center bg-yellow rounded-[50%] text-black dark:bg-white text-[22px] md:text-abse s16:text-lg max-md:text-[22px] font-medium leading-[100%]">
                {bets.length}
              </span>
              Betslip
            </>
          )}
        </span>
      </div>
      <BottomNavigation onBetslipClick={handleToggles} showBetslip={true} />
      <MobileSportsBetslip isDarkMode={isDarkMode} isOpen={isOpen} />
    </Layout>
  );
};

export default HomeLayout;
